// extracted by mini-css-extract-plugin
module.exports = {"review":"Review_review__2HITw"};